import { ButtonStyle } from 'common/button';
import { LabeledText } from 'common/labeled-text';
import { LinkButton } from 'common/link-button';
import cardStyles from 'common/settings-layout/settings-card.module.scss';
import { classnames } from 'helpers/utils';
import { goToPage, RouteName } from 'routes';
import styles from './owner-section.module.scss';

type OwnerSectionProps = {
  vault: VaultType;
  isOwner: boolean;
};

const OwnerSection = ({ vault, isOwner }: OwnerSectionProps) => (
  <div className={classnames(cardStyles.card, styles.ownerSection)}>
    <div className={cardStyles.cardHeader}>
      <p className="text__title2__gray800">Owner</p>
      {isOwner && (
        <LinkButton
          buttonStyle={ButtonStyle.LinkColor}
          onClick={() => goToPage(RouteName.Account)}
        >
          Modify in account settings
        </LinkButton>
      )}
    </div>
    <LabeledText
      label="Vault Owner"
      text={`${vault.owner.name} (${vault.owner.email})`}
      className={styles.line}
    />
    {vault.owner.companyName && (
      <LabeledText
        label="Company name"
        text={vault.owner.companyName}
        className={styles.line}
      />
    )}
  </div>
);

export { OwnerSection };
